module.exports = __webpack_public_path__ + "static/media/shay-murtagh-precast.c82fdee9.png";